import { Model, Position } from 'src/types'

export const atomsYouthFilterLogic = (m: Model): boolean => m.series === 'youth'

export const positionFilterLogic = (position: Position) => (m: Model) => m.position.includes(position)
